import { motion } from "framer-motion";
import { 
  FlashIcon, 
  ArrowLeft02Icon, 
  Clock01Icon,
  CheckmarkCircle02Icon,
  UserIcon
} from "hugeicons-react";
import SectionBadge from "../ui/SectionBadge";
import Magnetic from "../ui/Magnetic";

export default function QuickBookingSection({ onOpenBooking }: { onOpenBooking?: () => void }) {
  return (
    <section className="py-24 relative overflow-hidden bg-[#020000]">
      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 blur-[120px] rounded-full" />
        <div className="absolute inset-0 opacity-[0.03] bg-[url('/grid.svg')] bg-[length:40px_40px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center" dir="rtl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex flex-col items-center gap-6"
          >
            <SectionBadge text="حجز سريع" icon={FlashIcon} />
            
            <h2 className="text-4xl md:text-6xl font-black text-white tracking-tight">
              احجز موعدك في <span className="text-primary italic">30 ثانية</span> فقط
            </h2>
            
            <p className="text-gray-400 text-lg md:text-xl max-w-2xl leading-relaxed">
              وفر وقتك وجهدك. نظام الحجز الذكي لدينا يضمن لك مكاناً في أقل من دقيقة. بساطة، سرعة، واحترافية.
            </p>

            {/* Steps Preview */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mt-12 mb-16">
              {[
                { icon: UserIcon, text: "أدخل معلوماتك" },
                { icon: Clock01Icon, text: "اختر الموعد" },
                { icon: CheckmarkCircle02Icon, text: "تم التأكيد!" },
              ].map((step, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="flex flex-col items-center gap-4 p-8 rounded-3xl bg-white/[0.03] border border-white/5 backdrop-blur-sm"
                >
                  <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center text-primary border border-primary/20">
                    <step.icon size={24} />
                  </div>
                  <span className="text-white font-bold">{step.text}</span>
                </motion.div>
              ))}
            </div>

            <Magnetic>
              <button
                onClick={onOpenBooking}
                className="group relative h-20 px-12 text-2xl font-black rounded-2xl overflow-hidden bg-primary text-white shadow-[0_20px_40px_rgba(220,10,50,0.4)] transition-all hover:scale-105 active:scale-95"
              >
                <div className="relative z-10 flex items-center gap-4">
                  <span>ابدأ الحجز الآن</span>
                  <ArrowLeft02Icon size={28} className="group-hover:-translate-x-2 transition-transform" />
                </div>
                {/* Shine effect */}
                <div className="absolute top-0 left-[-100%] group-hover:left-[100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-1000" />
              </button>
            </Magnetic>
            
            <div className="mt-8 flex items-center gap-2 text-primary/60 font-black text-xs uppercase tracking-widest">
              <div className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" />
              متاح حالياً للحجوزات الفورية
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
